import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {SplitText} from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);

/**
 * ImageReveal
 *
 * @class
 * @classdesc Animation de reveal d'image avec un background bleu.
 */
export class ImageReveal {
    /**
     * Constructor
     *
     * @param {Object[]} selectors - Tableau d'objets définissant les sélections DOM.
     * @param {string} selectors[].selector - Le sélecteur CSS pour la sélection.
     * @param {string} selectors[].position - Position de l'animation dans la timeline.
     * @param {Boolean} selectors[].mask - Ajouter un masque.
     * @param {String} selectors[].maskColor - Ajouter un overlay.
     * @param {String} selectors[].overlayColor - Ajouter un overlay.
     * @param {Object} timeLine - La timeline JS.
     */
    constructor(selectors, timeLine) {
        this.selectors = selectors;
        this.timeLine = timeLine;
    }

    init() {

        this.selectors.forEach(({selector, position = "<", mask = false, maskColor = "#fff", overlayColor = null}) => {
            if (document.querySelectorAll(selector)?.length > 0) {
                document.querySelectorAll(selector).forEach((el) => {
                    el.classList.add('image-reveal');
                    const overlay = overlayColor != null ? `<div class="image-reveal__overlay" style="background: ${overlayColor};"></div>` : `<div class="image-reveal__overlay"></div>`

                    el.insertAdjacentHTML('afterbegin', overlay);
                    if (mask) {
                        el.insertAdjacentHTML('afterbegin', `<div class="image-reveal__mask" style="background: ${maskColor};"></div>`);
                    }
                })
            }
        });
    }

    animate() {
        this.selectors.forEach(({selector, position = "<", mask = false}) => {


            if (document.querySelector(`${selector} video`)) {
                gsap.set(`${selector} > video`, {
                    opacity: 0
                });
                document.querySelector(`${selector} video`)?.pause();

            } else {
                gsap.set(`${selector} > img`, {
                    opacity: 0
                });
            }

            this.timeLine.from(`${selector} .image-reveal__overlay`, {
                xPercent: -100,
                duration: .5,
                ease: "power1.out",
                onComplete: () => {
                    if (document.querySelector(`${selector} video`)) {
                        gsap.set(`${selector} video`, {
                            opacity: 1
                        });

                        // restart the video
                        document.querySelector(`${selector} video`)?.play();
                    } else {
                        gsap.set(`${selector} img`, {
                            opacity: 1
                        });
                    }


                    if (mask) {
                        gsap.set(`${selector} .image-reveal__mask`, {
                            opacity: 0,
                            duration: .5,
                            ease: "power1.out",
                            onComplete: () => {
                                gsap.set(`${selector} .image-reveal__mask`, {
                                    display: 'none'
                                });
                            }
                        });
                    }
                }
            })

            this.timeLine.to(`${selector} .image-reveal__overlay`, {
                xPercent: 100,
                duration: .5,
                ease: "power1.in",
            }, ">")
        })
    }
}